/** Query key factory for access (docs/13-ACCESS.md); inline array literals are banned (CLAUDE.md). */
export const accessKeys = {
  all: () => ['access'] as const,
  /** One person's grants, by their login. */
  user: (userId: string) => [...accessKeys.all(), 'user', userId] as const,
  /** A directory person's access: their login's, or what waits for them until they sign in. */
  person: (personId: string) => [...accessKeys.all(), 'person', personId] as const,
  /** Logins no person is linked to yet, matching a search ("Link to a login"). */
  unlinkedLogins: (q: string) => [...accessKeys.all(), 'unlinked-logins', q] as const,
  /** A folder's or service type's Access list. */
  scope: (kind: 'folder' | 'service_type', id: string) =>
    [...accessKeys.all(), 'scope', kind, id] as const,
  /** Logins matching a search: whom access can be given to. */
  people: (q: string) => [...accessKeys.all(), 'people', q] as const,
  templates: () => [...accessKeys.all(), 'templates'] as const,
}
